<template>
  <CardModule class="mt-6" title="Dados Financeiros">
    <v-row class="mt-3 mb-5">
      <v-col cols="4">
        <BaseTextField
          label="Loja Neo Pay"
          placeholder="Insira o id da loja do neo pay"
          v-model="$marketplace.cadastro.idloja_neo"
          type="text"
          hide-details
        >
        </BaseTextField>
      </v-col>
      <v-col cols="4">
        <BaseSelect
          label="Tipo de forma de pagamento"
          hide-details
          :items="tipoFormaPag"
          item-text="value"
          item-value="key"
          placeholder="Selecione o tipo de forma de pagamento"
          v-model="$marketplace.cadastro.tipo_forma_pag"
          type="text"
        >
        </BaseSelect>
      </v-col>
      <v-col cols="4">
        <BaseAutocomplete
          v-model="$marketplace.cadastro.forma_pag"
          :items="FormaPag"
          label="Selecione as formas de pagamento"
          :filter="searchForm"
          chips
          color="blue-grey lighten-2"
          item-text="descricao"
          item-value="idforma_pag"
          multiple
          needSelection
          hide-details
          no-data-text="Nenhuma forma de pagamento encontrada"
        >
          <template v-slot:selection="{ item }">
            {{ item.descricao }},
          </template>
          <template v-slot:item="{ item }">
            {{ item.descricao }}
          </template>
        </BaseAutocomplete>
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import _ from "lodash";
export default {
  name: "lojas-gerenciar-dados-bancarios",
  components: {
    CardModule,
    BaseTextField,
    BaseAutocomplete,
    BaseSelect,
  },
  data() {
    return {};
  },
  computed: {
    tipoFormaPag() {
      return this.$marketplace.cadastro.tipoFormaPagamento;
    },
    FormaPag() {
      return _.orderBy(
        this.$loja_gerenciar.lista_forma_pagamento_loja,
        [forma_pag => forma_pag.descricao.toLocaleLowerCase()],
        ["descricao"]
      );
    },
  },
  methods: {
    clearInput() {
      this.SearchBandeiras = "";
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.banco_nome.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchForm(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  mounted() {
    if (this.$marketplace.cadastro.tipo_forma_pag === "DEFAULT") {
      this.$marketplace.cadastro.forma_pag = [];
      this.$loja_gerenciar.getFormasPagLojaDefault();
    }
  },
};
</script>
<style scoped>
.lojas-gerenciar-dados-cadastrais-subtitle {
  width: 487px;
  font-size: 1rem;
  align-self: flex-start;
  margin-top: 1.25rem;
}

@media (max-width: 1366px) {
  .lojas-dados-bancarios-container04 {
    width: 50%;
  }
}
</style>
